/**
 * Comparar texto que han escrito personas distintas.
 *
 * Vive aparte porque lo usan dos cosas que no deberian depender la una de la
 * otra: la busqueda y la deteccion de duplicados. Y porque las dos tienen que
 * tratar «Sóller» y «soller» como la misma palabra: nadie escribe la tilde al
 * buscar, y una busqueda que no encuentra lo que hay se abandona a la segunda
 * vez.
 */

/** Minusculas y sin tildes. Lo minimo para que dos personas coincidan. */
export function sinTildes(texto: string): string {
  return texto
    .normalize('NFD')
    // `NFD` separa la letra de su tilde; esto se queda solo con la letra.
    .replace(/[^\p{Letter}\p{Number}\s'/.,-]/gu, '')
    .toLowerCase();
}

/**
 * Los prefijos de via que la gente escribe de diez maneras. Solo se quitan
 * cuando van DELANTE: «Cami de Son Vic» es el nombre de la calle, no un
 * prefijo, y borrarlo por estar en la lista dejaba «de son vic 14», que ya no
 * coincide con nada.
 */
const PREFIJO_VIA =
  /^(c|calle|carrer|avda|avenida|av|ctra|carretera|urb|urbanizacion|paseo|passeig|placa|plaza)\s+/;

/**
 * Direccion comparable: sin puntuacion, sin tildes, sin prefijo de via y sin
 * espacios de sobra. «C/ Camí de Son Vic, 14» y «Cami de Son Vic 14» son la
 * misma direccion escrita por dos personas distintas.
 */
export function normalizar(texto: string): string {
  const base = texto
    .normalize('NFD')
    .toLowerCase()
    // Fuera todo lo que no sea letra basica o digito. Esto se lleva por delante
    // la puntuacion, la barra de «C/» y las tildes que `NFD` acaba de separar.
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
  return base.replace(PREFIJO_VIA, '');
}

/**
 * ¿Alguno de estos campos contiene lo que se ha escrito?
 *
 * Se compara con `sinTildes` en los dos lados, porque quien busca «climatizacion»
 * tiene que encontrar «climatización»; y una busqueda vacia no filtra nada, que
 * es lo que hace que el campo se pueda dejar en paz.
 */
export function contiene(campos: Array<string | null | undefined>, busqueda: string): boolean {
  const aguja = sinTildes(busqueda).trim();
  if (aguja === '') return true;
  return campos.some((c) => (c ? sinTildes(c).includes(aguja) : false));
}
